module.exports = __webpack_public_path__ + "static/media/actions-icon.e27611c1.svg";